'use strict';

import { cn_building, cn_space, cn_storey } from '../../..';
import { cn_normalize, cn_sub } from '../../cn_utilities';
import { cn_element_visitor } from '../cn_element_visitor';

//***********************************************************************************
//***********************************************************************************
//**** cn_space_of_elements_visitor
//***********************************************************************************
//***********************************************************************************

export class cn_space_of_elements_visitor extends cn_element_visitor {

    /**
     *  Constructor
     *  @param {cn_storey} storey
     */
    constructor(storey) {
        super();
        this.storey = storey;
        this.spaces = [];
        this.spaces_uniq_ref = new Set()
    }

    visit_wall(cn_wall) {
        cn_wall.space_segments.forEach(ss => {
            if (ss.space) this._add_space(ss.space);
        });
    }

    visit_opening(cn_opening) {
        this.visit_wall(cn_opening.wall);
    }

    visit_slab(cn_slab) {
        if (cn_slab.spaces[1]) {
            this._add_space(cn_slab.spaces[1]);
        }
    }

    visit_beam(cn_beam) {
        cn_beam.get_spaces().forEach(space => this._add_space(space));
    }

    visit_column(cn_column) {
        const space = this.storey.scene.find_space(cn_column.position);
        this._add_space(space);
    }

    visit_object(cn_object_instance) {
        this._add_space(cn_object_instance.space);
    }

    visit_stairs(cn_stairs) {
        this._add_space(cn_stairs.space);
    }

    visit_pipe(cn_pipe) {
        this.storey.scene.get_spaces_on_path(cn_pipe.vertices[0], cn_pipe.vertices[1]).forEach(sd => this._add_space(sd.space));
    }

    /**
     *  Add uniq space in list
     *
     * @param {cn_space} space
     */
    _add_space(space) {
        if (space && !space.outside) {
            const key = `space#${space.ID}`;
            if (!this.spaces_uniq_ref.has(key)) {
                this.spaces_uniq_ref.add(key);
                this.spaces.push({
                    space_id: space.ID,
                    space_name: space.get_name(this.storey),
                    storey_id: this.storey.ID,
                });
            }
        }
    }

    visit_marker(cn_marker) {

    }

    visit_sampling(cn_marker) {

    }

}
